import { render, staticRenderFns } from "./CourseFooter.vue?vue&type=template&id=4dabb4cb&scoped=true"
import script from "./CourseFooter.vue?vue&type=script&lang=js"
export * from "./CourseFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dabb4cb",
  null
  
)

export default component.exports